export enum AccessLevel {
  ADMIN = 1,
  SYSTEM_ADMIN = 2,
  CONSULTANT = 0
}
